module.exports = __webpack_public_path__ + "img/CoverPlaceholder.5c34afea.svg";